import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-1rajo67-0"
})(["&.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}&:focus{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}&:focus.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], UiConstants.COLOR_VALUE_INVALID, UiConstants.COLOR_SELECTION_HIGHLIGHT, UiConstants.COLOR_VALUE_INVALID);
export const InputWithMargin = styled(Input).withConfig({
  displayName: "Input__InputWithMargin",
  componentId: "sc-1rajo67-1"
})(["margin:4px;"]);